// External Dependencies:
import React from 'react'
import { Link, NavLink } from 'react-router-dom'

class HelpPage extends React.Component {
	render() {
		return (
			<div className="mobile-app-top-page">
				<div className="-bg"></div>

				<div className="-menu">
					<NavLink to='/get-involved' exact activeClassName="is-active">Get Involved</NavLink>
					<NavLink to='/promote' exact activeClassName="is-active">Promote Faith FM</NavLink>
					<NavLink to='/votd' exact activeClassName="is-active">Verse of the Day</NavLink>
					<NavLink to='/donate' exact activeClassName="is-active">Donate</NavLink>
				</div>
			</div>
		)
	}
}

export default HelpPage
